import { ActionTypes } from '../constants/actionTypes';

const initialState = {
    loading: false,
    releaseDetailsData: [],
    selectedStatus : "All Releases",
    prevSelectedStatus: "All Releases",
    rejection_reason:"",
    release_notes_text: "",
    error: null,
    informationAlert: false,
    informationAlertText:"",
    notesDownloadReducerLoader: false,
}

export const releaseManagementReducer = (state= initialState, {type, payload}) => {
  switch(type) {
    case ActionTypes.SET_APPROVAL_STATUS:
        return{...state, selectedStatus: payload, prevSelectedStatus: state.selectedStatus};
    case ActionTypes.FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_REQUEST:
      return{...state, loading: true}
    
    case ActionTypes.FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_DATALIST:
      return {...state,
        releaseDetailsData:payload.response,
        loading: false,
        error: null,
        };
    case ActionTypes.RESET_RELEASE_MANAGEMENT_COMPONENT_DETAILS_DATALIST:
      return {
        ...state,
        releaseDetailsData: [],
      };
    case ActionTypes.FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_FAILURE:
      return{
        ...state,
        loading: false,
        error: payload
      };
    case ActionTypes.SET_REJECTION_REASON:
      return {
        ...state,
        rejection_reason: payload
      }
    case ActionTypes.FETCH_RELEASE_NOTES_DOWNLOAD_REQUEST:
      return {
        ...state,
        notesDownloadReducerLoader: true
      }
    case ActionTypes.SET_INFORMATION_ALERT:
      return {
        ...state,
        informationAlert: payload.active,
      }
      case ActionTypes.SET_INFORMATION_ALERT_TEXT:
        return {
          ...state,
          releaseNotesText: payload.text,
          notesDownloadReducerLoader: false
        }
       case ActionTypes.STATUS_TOASTMESSAGE:
        return {
          ...state,
          notesDownloadReducerLoader: false,
          informationAlert: false
        }
    default:
    return state;
  }
}